(function () {
  'use strict';

  angular.module('eclipseApp.components').config(['$stateProvider', function ($stateProvider) {
    //$stateProvider
    //  .state('wireless', {
    //    url: '/wireless',
    //    parent: 'app',
    //    data: {
    //      service: 'wireless'
    //    },
    //    views: {
    //      content: {
    //        templateUrl: 'modules/wireless/views/wireless.html',
    //        controller: 'wirelessCtrl'
    //      }
    //    }
    //  });

    // FUSS-1560 : Maintenance Page when Middleware is down (after login)

      $stateProvider
      .state('loginError', {
        url: '/maintenancePage',
        parent: 'app',
        title: "maintenance",
        views: {
          content: {
            templateUrl: 'modules/components/views/login-error.html'

          }
        }
      });



  }]);

})();
